import { Helmet } from 'react-helmet';

export const OrganizationSchema = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "EducationalOrganization",
    "name": "ULC World",
    "alternateName": "ULC World - UK Education & Immigration Consultants",
    "url": "https://www.ulcworld.com",
    "logo": "https://www.ulcworld.com/ulc-logo.png",
    "description": "Expert UK student visa and university application consultancy with 17+ years of experience. IAA registered adviser providing comprehensive immigration and education services.",
    "email": "info@ulcworld.com",
    "telephone": "+44 775 361 41 51",
    "foundingDate": "2008",
    "address": [
      {
        "@type": "PostalAddress",
        "streetAddress": "Unit 2A, 2nd Floor, Cavendish House, 369 Burnt Oak Broadway, Edgware",
        "addressLocality": "Middlesex, London",
        "postalCode": "HA8 5AW",
        "addressCountry": "GB"
      },
      {
        "@type": "PostalAddress",
        "streetAddress": "89, Kesbewa Road, Boralesgamuwa",
        "addressLocality": "Colombo",
        "postalCode": "10290",
        "addressCountry": "LK"
      }
    ],
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "telephone": "+44 775 361 41 51",
        "contactType": "customer service",
        "areaServed": ["GB", "LK", "IN", "PK", "BD"],
        "availableLanguage": ["English", "Sinhala", "Tamil"]
      },
      {
        "@type": "ContactPoint",
        "telephone": "+94 706 930 830",
        "contactType": "customer service",
        "areaServed": ["LK", "IN", "MV"],
        "availableLanguage": ["English", "Sinhala", "Tamil"]
      }
    ],
    "sameAs": [
      "https://www.facebook.com/ulcworld",
      "https://www.instagram.com/ulcworld/",
      "https://www.youtube.com/channel/UCmuiCa9wC93YC1kY_vzc7lg",
      "https://www.tiktok.com/@ulcworld"
    ],
    "areaServed": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": "51.5074",
        "longitude": "-0.1278"
      }
    },
    "serviceType": [
      "UK Student Visa Consultation",
      "University Application Support",
      "UK Immigration Services",
      "Dependent Visa Support",
      "IELTS Preparation",
      "Education Counselling"
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "500",
      "bestRating": "5",
      "worstRating": "1"
    },
    "hasCredential": {
      "@type": "EducationalOccupationalCredential",
      "credentialCategory": "IAA Registration",
      "recognizedBy": {
        "@type": "Organization",
        "name": "International Association of Administrators"
      }
    }
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "ULC World",
    "alternateName": "ULC World - UK Education & Immigration Consultants",
    "url": "https://www.ulcworld.com/",
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.ulcworld.com/courses?search={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
    </Helmet>
  );
};

